/* Hausgem — gentle auto-advance for product-card carousels (e.g. MOST POPULAR).
   Loops, pauses on hover/touch/focus and when the tab is hidden, respects reduced motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var DELAY = 4000;

  function setup(sc) {
    if (sc.dataset.hgAuto) return;
    if (sc.closest('.product__media-wrapper')) return;          // skip product-page gallery
    var slider = sc.querySelector('ul.slider');
    if (!slider || !slider.querySelector('.card-wrapper')) return; // only product-card carousels
    var slides = slider.querySelectorAll('.slider__slide');
    if (slides.length < 2) return;
    sc.dataset.hgAuto = '1';

    var paused = false;
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (e) {
      sc.addEventListener(e, function () { paused = true; }, { passive: true });
    });
    sc.addEventListener('mouseleave', function () { paused = false; });

    var next = sc.querySelector('.slider-button--next');
    setInterval(function () {
      if (paused || document.hidden) return;
      if (slider.scrollWidth <= slider.clientWidth + 4) return;   // nothing to scroll
      var atEnd = slider.scrollLeft >= (slider.scrollWidth - slider.clientWidth - 4);
      if (atEnd) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (next && !next.disabled) {
        next.click();
      } else {
        slider.scrollTo({ left: slider.scrollLeft + slider.clientWidth * 0.9, behavior: 'smooth' });
      }
    }, DELAY);
  }

  function init() { document.querySelectorAll('slider-component').forEach(setup); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
